var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMistralAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "233px",
    viewBox: "0 0 256 233",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mistral AI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 186.181818,
    y: 0,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D046",
    x: 209.454545,
    y: 0,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 0,
    y: 0,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 0,
    y: 46.5454545,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 0,
    y: 93.0909091,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 0,
    y: 139.636364,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 0,
    y: 186.181818,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F7D046",
    x: 23.2727273,
    y: 0,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2A73B",
    x: 209.454545,
    y: 46.5454545,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2A73B",
    x: 23.2727273,
    y: 46.5454545,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 139.636364,
    y: 46.5454545,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2A73B",
    x: 162.909091,
    y: 46.5454545,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2A73B",
    x: 69.8181818,
    y: 46.5454545,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE792F",
    x: 116.363636,
    y: 93.0909091,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE792F",
    x: 162.909091,
    y: 93.0909091,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE792F",
    x: 69.8181818,
    y: 93.0909091,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 93.0909091,
    y: 139.636364,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EB5829",
    x: 116.363636,
    y: 139.636364,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE792F",
    x: 209.454545,
    y: 93.0909091,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EE792F",
    x: 23.2727273,
    y: 93.0909091,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 186.181818,
    y: 139.636364,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EB5829",
    x: 209.454545,
    y: 139.636364,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 186.181818,
    y: 186.181818,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EB5829",
    x: 23.2727273,
    y: 139.636364,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EA3326",
    x: 209.454545,
    y: 186.181818,
    width: 46.5454545,
    height: 46.5454545
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EA3326",
    x: 23.2727273,
    y: 186.181818,
    width: 46.5454545,
    height: 46.5454545
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistralAiIcon);
export default __webpack_public_path__ + "static/media/mistral-ai-icon.027143811e4c3feb1b434a3e8a13ffa7.svg";
export { ForwardRef as ReactComponent };